<template>
  <div id="SelectPage">
    <div class="selectArea">
      <div class="titleArea">请选择身份进入</div>
      <div>
        <el-radio v-model="radio" label="应届毕业生">应届毕业生</el-radio>
        <el-radio v-model="radio" label="历届毕业生">历届毕业生</el-radio>
        <el-button
          type="primary"
          icon="el-icon-right"
          size="small"
          @click="clickMehtod"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "应届毕业生",
    };
  },
  methods: {
    clickMehtod() {
      alert(this.radio);
      //做对应的路由跳转
    },
  },
  mounted() {},
};
</script>

<style lang="less">
#SelectPage {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  //border: 1px solid gray;

  // background: url("../assets/img/bj.jpg") no-repeat;
  // background-size: 100% 100%;

  .selectArea {
    width: 50%;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    //border: 1px solid gray;
    box-shadow: 0 15px 15px #d2d2d2;
    background-color: rgba(243, 243, 243, 0.39);
    .titleArea {
      color: #24b1ff;
      font-size: 1.5em;
      .container {
        height: 100vh;
        display: flex; /* 弹性布局,水平，垂直居中*/
        justify-content: center;
        align-items: center;
        // background: #333;
      }
      span {
        font-size: 100px;
        font-weight: bold;
        text-transform: uppercase; /* 转为大写*/
        letter-spacing: 5px; /* 字间距*/
        color: #111;
        filter: blur(2px); /* 模糊滤镜*/
        animation: animate 2.5s linear infinite; /* 动画：动画名称 动画时长 线性的 无限次播放*/
      }
      /* 为每一个span元素设置动画延迟时间*/
      span:nth-child(1) {
        animation-delay: 0s;
      }
      span:nth-child(2) {
        animation-delay: 0.25s;
      }
      span:nth-child(3) {
        animation-delay: 0.5s;
      }
      span:nth-child(4) {
        animation-delay: 0.75s;
      }
      span:nth-child(5) {
        animation-delay: 1s;
      }
      span:nth-child(6) {
        animation-delay: 1.25s;
      }
      span:nth-child(7) {
        animation-delay: 1.5s;
      }
      span:nth-child(8) {
        animation-delay: 1.75s;
      }
      span:nth-child(9) {
        animation-delay: 2s;
      }
      @keyframes animate {
        /* 定义动画关键帧*/
        0%,
        100% {
          color: #fff;
          filter: blur(2px); /*模糊滤镜*/
          text-shadow: 0 0 10px #32ff7e, 0 0 20px #32ff7e, 0 0 30px #32ff7e,
            0 0 40px #32ff7e, 0 0 100px #32ff7e, 0 0 200px #32ff7e;
        }
        5%,
        95% {
          color: #111;
          filter: blur(0px);
        }
      }
    }
    .el-radio__label {
      font-size: 1.5em;
    }
  }
}
</style>
